import {
  type BaseIntegrationConfigs,
  IntegrationTypes,
  type MsGraphIntegrationConfigs,
  type UsageIntegrationConfig,
} from "../types";
import { type SfIntegrationConfigs } from "../types/successFactors";
import { type VivaIntegrationConfigs } from "../types/viva";
import IntegrationConfiguration from "./IntegrationConfiguration";
import MsGraphIntegrationConfiguration from "./MsGraphIntegrationConfiguration";
import SfIntegrationConfiguration from "./SfIntegrationConfiguration";
import VivaIntegrationConfiguration from "./VivaIntegrationConfiguration";
import type { Dispatch as ReactDispatch, SetStateAction } from "react";

export interface IntegrationConfigurationWrapperProps {
  connectorTitle: string;
  configuration: BaseIntegrationConfigs;
  updateConfig: ReactDispatch<SetStateAction<BaseIntegrationConfigs>>;
  integrationType: string;
  setIsValid: (isValid: boolean) => void;
  accountId: number;
}

export const IntegrationConfigurationWrapper: React.FC<IntegrationConfigurationWrapperProps> = (props) => {
  const { connectorTitle, configuration, updateConfig, integrationType, setIsValid, accountId } = props;

  return (() => {
    switch (integrationType) {
      case IntegrationTypes.Viva:
        return (
          <VivaIntegrationConfiguration
            isCreating
            integrationName={connectorTitle}
            setConfigs={updateConfig}
            configs={configuration as VivaIntegrationConfigs}
            accountId={accountId}
          />
        );
      case IntegrationTypes.SuccessFactors:
        return (
          <SfIntegrationConfiguration
            integrationName={connectorTitle}
            onUpdate={updateConfig}
            initialConfig={configuration as SfIntegrationConfigs}
            onIsValidChange={setIsValid}
            renderHeader
            accountId={accountId}
          />
        );
      case IntegrationTypes.MsGraph:
        return (
          <MsGraphIntegrationConfiguration
            isCreating
            setIsValid={setIsValid}
            integrationName={connectorTitle}
            setConfigs={updateConfig as unknown as ReactDispatch<SetStateAction<MsGraphIntegrationConfigs | undefined>>}
            configs={configuration as MsGraphIntegrationConfigs}
          />
        );
      default:
        return (
          <IntegrationConfiguration
            isCreating
            integrationName={connectorTitle}
            setConfigs={updateConfig}
            integrationType={integrationType}
            configs={configuration as UsageIntegrationConfig}
          />
        );
    }
  })();
};

export default IntegrationConfigurationWrapper;
